document.addEventListener('DOMContentLoaded', function () {
  const initializedGalleries = new WeakSet();

  function initCardGallery(cardGallery) {
    if (!cardGallery || initializedGalleries.has(cardGallery)) return;
    initializedGalleries.add(cardGallery);

    // Find the slideshow associated with *this* card-gallery
    const scroller =
      cardGallery.querySelector('slideshow-slides[ref="scroller"]') ||
      cardGallery.querySelector('slideshow-slides');

    if (!scroller) return;

    const slides = Array.from(scroller.querySelectorAll('slideshow-slide'));
    if (!slides.length) return;

    let currentIndex     = -1;
    let indicatorWidthPx = 0;

    function updateIndicatorWidth() {
      const afterStyles = getComputedStyle(cardGallery, '::after');
      const w = parseFloat(afterStyles.width);
      if (!isNaN(w)) indicatorWidthPx = w;
    }

    updateIndicatorWidth();

    // You can keep this global or per-gallery; per-gallery is fine performance-wise
    window.addEventListener('resize', updateIndicatorWidth);

    function setActiveSlide(index) {
      if (index === currentIndex || indicatorWidthPx === 0) return;
      currentIndex = index;

      const offset = indicatorWidthPx * index;
      cardGallery.style.setProperty('--pagination-offset', `${offset}px`);
    }

    const mutationObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
          const slide = mutation.target;
          if (slide.getAttribute('aria-hidden') === 'false') {
            const index = slides.indexOf(slide);
            if (index !== -1) setActiveSlide(index);
          }
        }
      }
    });

    slides.forEach((slide) => {
      mutationObserver.observe(slide, {
        attributes: true,
        attributeFilter: ['aria-hidden'],
      });

      // Pick up initial active slide per gallery
      if (slide.getAttribute('aria-hidden') === 'false') {
        const index = slides.indexOf(slide);
        if (index !== -1) setActiveSlide(index);
      }
    });
  }

  function scanForGalleries(root = document) {
    root.querySelectorAll('.card-gallery').forEach(initCardGallery);
  }

  // 1) Initial page load
  scanForGalleries();

  // 2) Catch anything injected later (including pair-with section)
  const domObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        // If the node itself is a card-gallery
        if (node.matches('.card-gallery')) {
          initCardGallery(node);
        } else {
          // Or if it *contains* any card-gallery
          scanForGalleries(node);
        }
      });
    }
  });

  domObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // 3) Extra safety: hook into Shopify's section load event
  document.addEventListener('shopify:section:load', function (event) {
    scanForGalleries(event.target);
  });
});